module.exports = __webpack_public_path__ + "static/media/supplier-community-palletyard.595a7022.png";